"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractionVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _interaction = require("../block/interaction");
var _variables = require("@blockwell/variables");
class InteractionVariable extends _variables.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", InteractionVariable.settings);
    (0, _defineProperty2.default)(this, "type", "interaction");
    (0, _defineProperty2.default)(this, "label", "interaction");
    (0, _defineProperty2.default)(this, "description", "Variable that holds and resolves interaction details in blocks.");
  }
  dependencies(params, resolver) {
    let deps = {
      type: params.type,
      actions: []
    };
    let actions = params.actions;
    if (actions) {
      for (let it of actions) {
        let type = _interaction.actionRegistry.get(it.type);
        if (type) {
          let action = type.resolve(it, resolver);
          deps.actions.push(action);
        }
      }
    }
    return deps;
  }
  async value(deps, batcher) {
    return {
      type: deps.type,
      actions: deps.actions
    };
  }
}
exports.InteractionVariable = InteractionVariable;
(0, _defineProperty2.default)(InteractionVariable, "settings", {});
//# sourceMappingURL=InteractionVariable.js.map